import type { Bounds, Range } from 'quill/core';
import type { Blot } from '../../types';

interface CellManager {
  getActiveCellIdentity(): string | null;
  getCellLastRange(identity: string): Range | null;
  getCellClientRects(cell: {
    identity: string;
    index: number;
    length: number;
  }): Bounds[];
  getBounds(cell: {
    identity: string;
    index: number;
    length: number;
  }): Bounds | null;
}

export const isCellManager = (blot: Blot): blot is Blot & CellManager =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  !!blot && typeof (blot as any).getActiveCellIdentity === 'function';

export default CellManager;
